export const MODAL_STATE = {
  builder: 'builder',
  create: 'create',
};

export const FLOW_TYPE = 'flows';
export const PIN_TYPE = 'pins';

export const TEMPLATES = [
  {
    label: 'Welcome to the family',
    description: 'Greet new users with an overview',
    value: 'evaluators',
    screenshotUrl:
      'https://res.cloudinary.com/dnjrorsut/image/upload/v1561052913/reactcues-assets/Evaluator_1.png',
    size: { width: 54.15, height: 46.77 },
  },
  {
    label: 'Webinar promotion',
    description: 'Keep users informed with resources',
    value: 'bigener',
    screenshotUrl:
      'https://res.cloudinary.com/dnjrorsut/image/upload/v1561052913/reactcues-assets/Beginner_1.png',
    size: { width: 36.92, height: 54.15 },
  },
  {
    label: 'New feature release',
    description: 'Point out new features with a slideout',
    value: 'regular',
    screenshotUrl:
      'https://res.cloudinary.com/dnjrorsut/image/upload/v1561052913/reactcues-assets/Regular_1.png',
    size: { width: 40.62, height: 54.15 },
  },
];
